var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineDocumentLike(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    "data-name": "vuesax/outline/document-like"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 22.75H8c-3.65 0-5.75-2.1-5.75-5.75V7c0-3.65 2.1-5.75 5.75-5.75h8c3.65 0 5.75 2.1 5.75 5.75v10c0 3.65-2.1 5.75-5.75 5.75zm-8-20C5.14 2.75 3.75 4.14 3.75 7v10c0 2.86 1.39 4.25 4.25 4.25h8c2.86 0 4.25-1.39 4.25-4.25V7c0-2.86-1.39-4.25-4.25-4.25z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Vector",
    d: "M10.27 18.718a4.593 4.593 0 01-3.5-3 2.815 2.815 0 011.61-3.587 2.236 2.236 0 011.88.22 2.276 2.276 0 011.9-.22 2.839 2.839 0 011.63 3.587 4.606 4.606 0 01-3.52 3zm-2.07-3.46a3.349 3.349 0 002.11 1.96 3.328 3.328 0 002.05-1.96 1.35 1.35 0 00-.66-1.71.718.718 0 00-.8.22.73.73 0 01-.61.34.71.71 0 01-.63-.32.739.739 0 00-.82-.24 1.346 1.346 0 00-.64 1.713z"
  }))));
}
export default SvgVuesaxOutlineDocumentLike;